// extracted by mini-css-extract-plugin
export default {"root":"requisite_root__lVjTd","label":"requisite_label__H08Zc","value":"requisite_value___fRe8"};